
function errorHandler (errors) {
  let ret = ''
  if (!errors.response) {
    ret = { errors: [errors] }
  } else {
    ret = errors.response.data.errors !== undefined ? errors.response.data.errors : { error: [errors.toString()] }
  }
  return ret
}

export {
  errorHandler,
}
